import React, { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import { ArrowTriangleDown } from "../../../../../../constants/svg";
import {
  primaryProductList,
  salonJobType,
  SOFTWARE,
  status,
  TECHNOLOGY,
} from "../../../../../../utils/constants";
import { useSelector } from "react-redux";
import { GetPositions } from "../../../../../../services/positions/positions";
import { toastMessage } from "../../../../../../utils/helper";

const STAFF = "staff";
const ADMIN = "admin";

function JobTitleChip({ name, kind }) {
  if (!kind) return name;
  return (
    <span className="job-title-chip">
      <span className="job-title-chip-name">{name}</span>
      <span className={`job-title-chip-kind job-title-chip-kind--${kind}`}>
        {kind === ADMIN ? "Owner/Admin" : "Staff"}
      </span>
    </span>
  );
}

function toJobTitleOptions(rows, kind) {
  const list = Array.isArray(rows) ? rows : [];
  return list
    .map((item) => ({
      value: item.id,
      label: item.name,
      kind,
      order: Number(item.order) || 0,
    }))
    .sort(
      (a, b) => a.order - b.order || String(a.label).localeCompare(String(b.label)),
    );
}

const NewSegment = ({
  showPositions,
  getSalonSegments,
  setSelectedSalons,
  selectedSalons,
  selectedProductLines,
  selectedPositions,
  setSelectedProductLines,
  setSelectedPositions,
  zeroStepData,
  softwares,
  setSoftwares,
  technologies,
  setTechnologies,
}) => {
  const [size, setSize] = useState("middle");
  const [salons, setSalons] = useState([]);
  const [jobTitleOptions, setJobTitleOptions] = useState([]);
  const { positions, salonSegments } = useSelector((state) => state.global);
  useEffect(() => {
    let salonData = [];
    salonSegments.map((item) => {
      salonData.push({ label: item.name, value: item.id });
    });
    setSalons(salonData);
  }, [salonSegments]);
  useEffect(() => {
    getSalonSegments();
  }, []);
  useEffect(() => {
    if (!showPositions) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const params = { is_paginated: 0, status: status.active };
        const [staffRes, adminRes] = await Promise.all([
          GetPositions(params),
          GetPositions({ ...params, type: salonJobType.admin }),
        ]);
        if (cancelled) return;
        setJobTitleOptions([
          {
            label: "Staff",
            options: toJobTitleOptions(staffRes?.data?.data, STAFF),
          },
          {
            label: "Owner / Admin",
            options: toJobTitleOptions(adminRes?.data?.data, ADMIN),
          },
        ]);
      } catch (e) {
        if (!cancelled) toastMessage("error", e.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [showPositions]);
  const positionKindByValue = useMemo(() => {
    const kinds = new Map();
    jobTitleOptions.forEach((group) => {
      (group.options || []).forEach((option) => {
        kinds.set(option.value, option.kind);
      });
    });
    return kinds;
  }, [jobTitleOptions]);
  const primaryProduct = primaryProductList.map((product) => ({
    value: product,
    label: product,
  }));

  const handleSalonChange = (value) => {
    setSelectedSalons(value);
  };
  const handleProductLineChange = (value) => {
    setSelectedProductLines(value);
  };
  const handlePositionChange = (value) => {
    setSelectedPositions(value);
  };
  return (
    <div className="min_box new_segment">
      <div className="header_box">
        Filter recipients who match the following criteria:
      </div>
      <div className="all_select">
        <div className="select_box_new">
          <div className="select_label_new">AND</div>
          <div className="select_option_new">
            <Select
              showSearch
              value={selectedProductLines}
              mode="multiple"
              size={size}
              placeholder="Select Product Line"
              onChange={handleProductLineChange}
              style={{ width: "100%" }}
              options={primaryProduct}
              suffixIcon={<ArrowTriangleDown />}
              popupClassName="new_select_class"
            />
          </div>
        </div>
        {showPositions ? (
          <div className="select_box_new">
            <div className="select_label_new">AND</div>
            <div className="select_option_new">
              <Select
                className="job-title-select"
                showSearch
                value={selectedPositions}
                mode="multiple"
                size={size}
                placeholder="Select Job Title"
                onChange={handlePositionChange}
                style={{ width: "100%" }}
                options={jobTitleOptions.length ? jobTitleOptions : positions}
                optionFilterProp="label"
                suffixIcon={<ArrowTriangleDown />}
                popupClassName="new_select_class"
                labelRender={(option) => (
                  <JobTitleChip
                    name={option.label}
                    kind={positionKindByValue.get(option.value)}
                  />
                )}
              />
            </div>
          </div>
        ) : null}
        <div className="select_box_new">
          <div className="select_label_new">AND</div>
          <div className="select_option_new">
            <Select
              showSearch
              value={selectedSalons}
              mode="multiple"
              size={size}
              placeholder="Select Organizations"
              onChange={handleSalonChange}
              style={{ width: "100%" }}
              options={salons}
              suffixIcon={<ArrowTriangleDown />}
              popupClassName="new_select_class"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          </div>
        </div>
        <div className="select_box_new">
          <div className="select_label_new">AND</div>
          <div className="select_option_new">
            <Select
              showSearch
              value={softwares}
              mode="multiple"
              size={size}
              placeholder="Select Booking Software"
              onChange={setSoftwares}
              style={{ width: "100%" }}
              options={SOFTWARE.map((el) => ({ label: el, value: el }))}
              suffixIcon={<ArrowTriangleDown />}
              popupClassName="new_select_class"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          </div>
        </div>
        <div className="select_box_new">
          <div className="select_label_new">AND</div>
          <div className="select_option_new">
            <Select
              showSearch
              value={technologies}
              mode="multiple"
              size={size}
              placeholder="Select Technologies / Partners"
              onChange={setTechnologies}
              style={{ width: "100%" }}
              options={TECHNOLOGY.map((el) => ({ label: el, value: el }))}
              suffixIcon={<ArrowTriangleDown />}
              popupClassName="new_select_class"
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSegment;
